/**
 * Dashboard resolver — determines which home page a user should see.
 *
 * Resolution order:
 *   1. Explicit per-user dashboard_preference (from backend)
 *   2. Role-based default
 *
 * Roles → default dashboard:
 *   admin    → 'command-center'  (existing Dashboard)
 *   manager  → 'command-center'  (configurable later)
 *   staff    → 'operations'      (new employee page)
 *   supplier → 'operations'
 */

const ROLE_DEFAULTS = {
  admin:    'command-center',
  manager:  'command-center',
  staff:    'operations',
  supplier: 'operations',
};

const DASHBOARD_ROUTES = {
  'command-center': '/',
  'operations':     '/operations',
};

export function resolveDefaultDashboard(user) {
  if (!user) return '/login';

  // 1. Explicit preference (future: stored on user record)
  if (user.dashboard_preference && DASHBOARD_ROUTES[user.dashboard_preference]) {
    return DASHBOARD_ROUTES[user.dashboard_preference];
  }

  // 2. Role-based default
  const key = ROLE_DEFAULTS[user.role] || 'operations';
  return DASHBOARD_ROUTES[key] || '/operations';
}

export function getHomePath(user) {
  return resolveDefaultDashboard(user);
}

export function isOperationsUser(user) {
  if (!user) return false;
  // Staff/supplier always see Operations
  if (['staff', 'supplier'].includes(user.role)) return true;
  // Admin/manager see it only if explicitly preferred
  if (user.dashboard_preference === 'operations') return true;
  return false;
}

export function isCommandCenterUser(user) {
  if (!user) return false;
  // Admin/manager always see Command Center
  if (['admin', 'manager'].includes(user.role)) return true;
  // Staff/supplier see it only if explicitly preferred
  if (user.dashboard_preference === 'command-center') return true;
  return false;
}

export { ROLE_DEFAULTS, DASHBOARD_ROUTES };
